export const findServiceById = id => serviceArray => serviceArray.id === id;

export const findServiceByProperty = (
  property,
  propertyValue
) => serviceArray => serviceArray[property] === propertyValue;

export const sortArrayOfObjectsBy = param => (prev, next) => {
  if (prev[param] < next[param]) {
    return -1;
  }
  if (prev[param] > next[param]) {
    return 1;
  }
  return 0;
};



// WEBPACK FOOTER //
// ./src/utils/callbacks.js